import { render, staticRenderFns } from "./OrgInfo.vue?vue&type=template&id=2c58047f&scoped=true"
import script from "./OrgInfo.vue?vue&type=script&lang=js"
export * from "./OrgInfo.vue?vue&type=script&lang=js"
import style0 from "./OrgInfo.vue?vue&type=style&index=0&id=2c58047f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c58047f",
  null
  
)

export default component.exports